module.exports = __webpack_public_path__ + "static/img/35.6c2c930.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/35.png
// module id = jOqA
// module chunks = 0